import axiosInstance from '@/plugins/axios';

// Caixa Postal e-CAC (SERPRO Integra Contador via BFF /mensagens-ecac) — histórico
// persistido (coleta agendada + sincronizar manual usam a mesma rota ic/consultar do
// agnaldo, o cert por empresa é resolvido no backend).
const ServiceMensagensEcac = {
  sincronizar: (cnpj) => axiosInstance.post('mensagens-ecac/sincronizar', { cnpj }),
  search: (body) => axiosInstance.post('mensagens-ecac/search', body),
  dashboard: (cnpj) =>
    axiosInstance.get(`mensagens-ecac/dashboard?cnpj=${encodeURIComponent(cnpj)}`),
};

export default ServiceMensagensEcac;
